import cs from 'classnames';
import styled from 'styled-components';
//@ts-ignore
import Scrollbar from '@mindtickle/scrollbar';

export const getScrollProps = ({ isExpanded }: { isExpanded: boolean }) => ({
  style: { flex: 1 },
  classNames: {
    renderView: cs('navigation-scroll-view', {
      'expanded-scroll-view': isExpanded,
      'collapsed-scroll-view': !isExpanded,
    }),
  },
  hideTopBorderOnScroll: true,
});

export const StyledMainNavigation = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background-color: inherit;
`;

export const StyledMainNavigationScroll = styled(Scrollbar)`
  .navigation-scroll-view {
    display: flex;
    flex-direction: column;
  }

  .expanded-scroll-view {
    padding: 16px;
    gap: 8px;
  }

  .collapsed-scroll-view {
    padding: 16px 8px;
    gap: 12px;
  }
  .track-horizontal {
    display: none;
  }
  .track-vertical {
    width: 4px !important;
  }
`;
